import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import CalendarTableBody from './CalendarTableBody';
import CalendarTableHeader from './CalendarTableHeader';
import './style.scss';

/**
 * @param {Moment} day
 */

/**
 * @callback onAction
 */
/**
 * Calendar body
 * @param {Moment} day
 * @param {Array} range
 * @param {Array} week
 * @param {Array} data
 * @param {onAction} onAction
 */
function CalendarBody({ day = moment(), range, week, data, onAction, updateSort, isPermissionAvailable }) {
  const headDivRef = useRef();
  const bodyDivRef = useRef();
  const handleScrollHead = scroll => {
    bodyDivRef.current.scrollLeft = scroll.target.scrollLeft;
  }
  const handleScrollBody = scroll => {
    headDivRef.current.scrollLeft = scroll.target.scrollLeft;
  }

return (
    <div className="calendar_content">
      <div className="headers" onScroll={handleScrollHead} ref={headDivRef}>
        <CalendarTableHeader day={day} updateSort={updateSort} />
      </div>
      <div className="body calendar_body" onScroll={handleScrollBody} ref={bodyDivRef}>
        <CalendarTableBody data={data} onAction={onAction} week={week} day={day} range={range} isPermissionAvailable={isPermissionAvailable}/>
      </div>
    </div>
  );
}

CalendarBody.propTypes = {
  day: PropTypes.any,
  range: PropTypes.array,
  week: PropTypes.array,
  data: PropTypes.array,
  onAction: PropTypes.func.isRequired,
  updateSort: PropTypes.func,
  isPermissionAvailable: PropTypes.func
};

export default React.memo(CalendarBody);
